module.exports = __webpack_public_path__ + "img/about.3833c242.png";